<template>
  <md-dialog :md-active.sync="active" @md-closed="close">
    <md-dialog-title>{{ message }}</md-dialog-title>
    <md-dialog-content>
      <p v-for="(message, i) in subMessages" :key="i">{{ message }}</p>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button @click="close">{{ buttonTextCancel }}</md-button>
      <md-button class="md-primary md-raised" @click="ok">{{
        buttonTextOk
      }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { Subject } from 'rxjs'

/**
 * 「はい」「いいえ」選択用ダイアログ
 */
export default {
  data() {
    const subject = new Subject()
    return {
      active: false,
      afterClosed: subject,
      afterClosed$: subject.asObservable(),
      message: undefined,
      subMessage: undefined,
      buttonTextOk: 'はい',
      buttonTextCancel: 'キャンセル',
    }
  },
  computed: {
    subMessages() {
      if (!this.subMessage) {
        return []
      }

      if (Array.isArray(this.subMessage)) {
        return this.subMessage
      }

      return [this.subMessage]
    },
  },
  methods: {
    open({ message, subMessage, buttonTextOk, buttonTextCancel }) {
      this.message = message || this.message
      this.subMessage = subMessage || this.subMessage
      this.buttonTextOk = buttonTextOk || this.buttonTextOk
      this.buttonTextCancel = buttonTextCancel || this.buttonTextCancel
      this.active = true

      return this.afterClosed$
    },
    ok() {
      this.active = false
      this.afterClosed.next(true)
    },
    close() {
      this.active = false
      this.afterClosed.next(false)
    },
  },
}
</script>
